import React from 'react';

interface ISubtitle {
    number: string,
    text: string,
    qa?: string,
}

const Subtitle = (props: ISubtitle) => {
    return (
        <div className="flex items-center mb-4">
            <p className="mr-4 bg-blue-200 text-tiny font-bold text-gray-100 flex items-center justify-center" style={{
                width: '27px',
                height: '27px',
                borderRadius: '100%'
            }}>{ props.number }</p>
            <p className="text-2xl text-gray-700 font-bold" data-qa={ props.qa }>{ props.text }</p>
        </div>
    )
};

export default Subtitle;